"use strict";

const dropdownMenuSelector = '.notifications_wrap .dropdown-menu';
const notificationCountSelector = '.item_notifications .notification_count';
const unreadNotificationClass = 'notifications__unread';
function turnOnOffBackground(element) {
  const background = document.querySelector('.js_turnOnOffBackground');
  background.style.display = background.style.display === 'none' ? 'block' : 'none';
  if (element) {
    const allMenuEls = document.querySelectorAll(dropdownMenuSelector);
    const menuElement = element.parentNode.querySelector('.dropdown-menu');
    Array.from(allMenuEls).forEach(menuEl => {
      if (menuElement !== menuEl && !menuEl.classList.contains('hidden')) menuEl.classList.add('hidden');
    });
  }
}
function updateNofiticationCount() {
  const notificationCountEl = document.querySelector(notificationCountSelector);
  if (window.notificationCount > 0) window.notificationCount -= 1;
  if (notificationCountEl) {
    if (window.notificationCount > 9) {
      notificationCountEl.textContent = '9+';
    } else if (window.notificationCount === 0) {
      notificationCountEl.remove();
    } else {
      notificationCountEl.textContent = window.notificationCount;
    }
  }
}

// eslint-disable-next-line no-unused-vars
function toggleDropdownMenu(element, notificationId) {
  const allMenuEls = document.querySelectorAll(dropdownMenuSelector);
  const currentMenuEl = element.parentNode.querySelector('.dropdown-menu');
  const notificationEl = element.closest('.notification-item');
  Array.from(allMenuEls).forEach(menuEl => {
    if (currentMenuEl !== menuEl && !menuEl.classList.contains('hidden')) menuEl.classList.add('hidden');
  });
  if (notificationEl.classList.contains(unreadNotificationClass)) {
    notificationEl.classList.remove(unreadNotificationClass);
    window.Unicorn.call('item_notifications', 'mark_as_read', window.getUserToken(), notificationId);
    updateNofiticationCount();
  }
  currentMenuEl.classList.toggle('hidden');
  if (document.documentElement.clientWidth < 1024) turnOnOffBackground();
}

// eslint-disable-next-line no-unused-vars
function markAllAsRead(markAllBtn) {
  const notificationEls = document.querySelectorAll('.header__flyout_content .notification-item');
  const notificationCountEl = document.querySelector(notificationCountSelector);
  Array.from(notificationEls).forEach(notificationEl => {
    notificationEl.classList.remove(unreadNotificationClass);
  });
  markAllBtn.parentNode.classList.add('hidden');
  notificationCountEl.remove();
  window.Unicorn.call('item_notifications', 'mark_as_read', window.getUserToken(), 0);
  window.showSnackbar('Sve obavijesti su označene kao pročitane!', 'success');
}

// eslint-disable-next-line no-unused-vars
function unsubscribeFromTheme(element, themeId, content) {
  const themeName = content.split('Novo iz teme ')[1];
  const profileData = window.getProfileData();
  window.Unicorn.call('item_notifications', 'unsubscribe_from_theme', window.getUserToken(), profileData.id, themeId);
  window.showSnackbar(`Više ne pratiš temu ${themeName}`, 'success');
  element.closest('.notifications__dropdown').remove();
  element.remove();
}

// eslint-disable-next-line no-unused-vars
function blockUser(element, commentUserId) {
  window.Unicorn.call('item_notifications', 'block_user', window.getUserToken(), commentUserId);
  element.closest('.notifications__dropdown').remove();
  element.remove();
}

// eslint-disable-next-line no-unused-vars
function unsubscribeFromPost(element, rootCommentId) {
  const profileData = window.getProfileData();
  window.Unicorn.call('item_notifications', 'unsubscribe_from_post', window.getUserToken(), profileData.id, rootCommentId);
  element.closest('.notifications__dropdown').remove();
  element.remove();
}
function getFlyoutNotificationsElement() {
  return document.querySelector('.js_highlightOwnMentions');
}
function setActive() {
  const flyoutNotifications = getFlyoutNotificationsElement();
  const setActiveElement = document.querySelector('.js_setActive');
  if (flyoutNotifications) {
    setActiveElement.classList.add('is-active');
  } else {
    setActiveElement.classList.remove('is-active');
  }
}

// eslint-disable-next-line no-unused-vars
function highlightOwnMentions() {
  setActive();
  const flyoutNotifications = getFlyoutNotificationsElement();
  const markElements = flyoutNotifications ? flyoutNotifications.getElementsByTagName('mark') : null;
  if (markElements) {
    Array.from(markElements).forEach(item => {
      const mark = document.createElement('mark');
      mark.classList.add('own-mention');
      mark.innerText = item.innerText;
      mark.dataset.id = item.dataset.id;
      item.replaceChild(mark, item.childNodes[0]);
    });
  }
  function closeOpen(event) {
    const outsideClick = !flyoutNotifications.contains(event.target);
    const isCloseOpenButton = document.querySelector('.js_closeOpen').contains(event.target);
    if (outsideClick && !isCloseOpenButton) {
      document.removeEventListener('click', closeOpen);
      window.Unicorn.call('item_notifications', 'toggle_notifications_flyout', 'outside');
    } else if (outsideClick && isCloseOpenButton) {
      document.removeEventListener('click', closeOpen);
    }
  }
  if (flyoutNotifications) {
    document.addEventListener('click', closeOpen);
  }
}

// eslint-disable-next-line no-unused-vars
async function markAsReadAndGoToLink(event, element) {
  event.preventDefault();
  const notificationsUrl = `${window.baseApiUrl}/notifications/${element.dataset.notificationId}`;
  try {
    const notificationResponse = await fetch(notificationsUrl, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${window.getUserToken()}`
      },
      body: JSON.stringify({
        'is_read': true
      })
    });
    if (notificationResponse.status === 200) {
      element.parentNode.classList.remove(unreadNotificationClass);
      updateNofiticationCount();
    } else {
      console.error(`[Notifications] '${notificationsUrl}' resulted with error, please check response`, notificationResponse.json());
    }
  } catch (error) {
    console.error(`[Notifications] Fetching '${notificationsUrl}' resulted with error! \n`, error);
  }
  window.open(element.href, '_self');
}
window.addEventListener('DOMContentLoaded', () => {
  const userToken = window.getUserToken();
  if (userToken) {
    window.Unicorn.call('item_notifications', 'get_notifications', userToken);
  }
});